module.exports = __webpack_public_path__ + "static/media/dianrelan_banner4_hospital.2d944a28.png";